module.exports = __webpack_public_path__ + "img/dots-horizontal.2822a58.svg";